import { createStyles } from "@mantine/core";

export const useStyles = createStyles(() => ({
  resultWrapper: {
    height: "100%",
    width: "100%",
  },
}));
